import { Injectable } from '@angular/core';

import { ElementRef, Renderer2 } from '@angular/core';
import { SharedOperationService } from './shared-operation.service';
import { FormBuilderUDFService } from './form-builder-udf-service';
import { ListOperationService } from './list-operation.service';


@Injectable({
  providedIn: 'root'
})
export class DropdownOperationService {
  jsonData: any;
  dataFromShared: any;
  agGridInstances: any[] = [];
  renderer: Renderer2;
  container: any;

  constructor(private formService: FormBuilderUDFService, private sharedService: SharedOperationService,private listOperationService: ListOperationService ) {
    this.sharedService.formViewerData$.subscribe((data) => {
      if (data) {
        this.dataFromShared = data;
      }
    });
  }

  private dropdownUpdateState: { [key: string]: boolean } = {};

  async loadAndPopulateComponents(jsonData: any, el: ElementRef, renderer: Renderer2) {
    this.jsonData = jsonData;
    const container = el.nativeElement === undefined ? this.dataFromShared?.nativeElement : el.nativeElement;
    this.renderer = renderer;
    this.container = container;
    for (const component of jsonData.added_components) {
      if (component.addedComponents) {
        for (const innerComponents of component.addedComponents) {
          for (const innerComponent of innerComponents) {
            if (innerComponent.elementName === 'dropdown') {
              await this.populateDropdown(innerComponent.element, container, renderer);
              const firstDropdown = container.querySelector(`select[name="${innerComponent.element.field_name}"]`) as HTMLSelectElement;
              if (firstDropdown) {
                this.onDropdownChange(innerComponent.element.field_name, el, renderer);
              }
            } else if (innerComponent.elementName === 'list') {
              //const listOperationService = new ListOperationService(this.sharedService, this.formService);
              await this.listOperationService.createListGrid(innerComponent, container);
            }
          }
        }
      }
    }
  }

  async populateDropdown(element: any, container: HTMLElement, renderer: Renderer2): Promise<void> {
    const params = this.sharedService.constructDependentParams(element.field_name, container, this.getDropdownConfig.bind(this));
    const dropdownName = element.field_name;
    if (element.datasourceUrl) {
      return new Promise<void>((resolve, reject) => {
        this.sharedService.fetchDataFromAPI(params, element.datasourceUrl, element.requestType).then(data => {
          const dropdown = container.querySelector(`select[name="${dropdownName}"]`) as HTMLSelectElement;

          if (dropdown) {
            //const list = element.resultsetName !== '' ? data[element.resultsetName] : data;
            const list = element.resultsetName !== '' && element.resultsetName in data
              ? data[element.resultsetName]
              : data;

            dropdown.innerHTML = '';
            const parsedField = JSON.parse(element.resultsetfieldName);
            list?.forEach((item: any) => {
              const option = renderer.createElement('option');
              option.text = item[parsedField.text];
              option.value = item[parsedField.value];
              renderer.appendChild(dropdown, option);
            });

            dropdown.addEventListener('change', () => {
              this.onDropdownChange(dropdownName, { nativeElement: container }, renderer);
            });

            resolve();
          } else {
            console.error(`Dropdown with name ${dropdownName} not found or list not found in the response.`);
            reject();
          }
        }).catch(error => {
          console.error(`Error fetching data for ${dropdownName}:`, error);
          reject();
        });
      });
    } else {
      return Promise.resolve();
    }
  }

  async onDropdownChange(dropdownName: string, el: ElementRef, renderer: Renderer2) {
    const dependentDropdownNames = this.getDependentDropdownName(dropdownName);
    if (dependentDropdownNames === undefined) {
      return;
    }
    for (const dependentDropdownName of dependentDropdownNames) {
      const dependentParams = this.sharedService.constructDependentParams(dependentDropdownName, el.nativeElement, this.getDropdownConfig.bind(this));
      if (dependentParams) {
        await this.updateDependentDropdown(dependentDropdownName, dependentParams, el, renderer);
        const dependentDropdown = this.container === undefined ? this.dataFromShared?.nativeElement?.querySelector(`select[name="${dependentDropdownName}"]`) as HTMLSelectElement : this.container?.querySelector(`select[name="${dependentDropdownName}"]`) as HTMLSelectElement;
        if (dependentDropdown && dependentDropdown.options.length > 0) {
          setTimeout(() => {
            this.onDropdownChange(dependentDropdownName, el, renderer);
          }, 0);
        }
      }
    }

    this.dropdownUpdateState[dropdownName] = false;
  }

  async updateDependentDropdown(dependentDropdownName: string, params: any, el: ElementRef, renderer: Renderer2): Promise<void> {
    const container = el.nativeElement === undefined ? this.dataFromShared?.nativeElement : el.nativeElement;
    const dependentDropdown = this.findDropdownElement(dependentDropdownName, container);
    const elementConfig = this.getDropdownConfig(dependentDropdownName);
    if (dependentDropdown && elementConfig.elementName === 'dropdown') {
      if (elementConfig.elementName === 'dropdown') {
        return new Promise<void>((resolve, reject) => {
          this.sharedService.fetchDataFromAPI(params, elementConfig.element.datasourceUrl, elementConfig.element.requestType).then(data => {
           // const list = elementConfig.element.resultsetName !== '' ? data[elementConfig.element.resultsetName] : data;
           const list = elementConfig?.element.resultsetName !== '' && elementConfig?.element.resultsetName in data
           ? data[elementConfig?.element.resultsetName]
           : data;
            if (list) {
              dependentDropdown.innerHTML = '';
              const parsedField = JSON.parse(elementConfig.element.resultsetfieldName);
              list.forEach((item: any) => {
                const option = renderer.createElement('option');
                option.text = item[parsedField.text];
                option.value = item[parsedField.value];
                renderer.appendChild(dependentDropdown, option);
              });
              resolve();
            } else {
              console.error(`List not found in the response for ${dependentDropdownName}`);
              reject();
            }
          }).catch(error => {
            console.error(`Error fetching data for ${dependentDropdownName}:`, error);
            reject();
          });
        });
      } else {
        return Promise.resolve();
      }
    } else if (elementConfig?.elementName === 'list' && elementConfig?.element?.datasourceUrl) {
      //const listOperationService = new ListOperationService(this.sharedService, this.formService);
      await this.listOperationService.createListGrid(elementConfig, container);
    } else {
      return Promise.resolve();
    }
  }

  findDropdownElement(dropdownName: string, container: HTMLElement): HTMLSelectElement | null {
    return container === undefined ? this.dataFromShared?.nativeElement?.querySelector(`select[name="${dropdownName}"]`) as HTMLSelectElement : container?.querySelector(`select[name="${dropdownName}"]`) as HTMLSelectElement;
  }

  getDropdownConfig(dropdownName: string): any {
    let config = null;
    this.jsonData = this.jsonData === undefined ? this.dataFromShared?.json_data : this.jsonData;
    this.jsonData.added_components.forEach((component: any) => {
      if (component.addedComponents) {
        component.addedComponents.forEach((innerComponents: any[]) => {
          innerComponents.forEach((innerComponent: any) => {
            if (innerComponent.elementName === 'dropdown' && innerComponent.element.field_name === dropdownName) {
              config = innerComponent;
            } else if (innerComponent.elementName === 'list' && innerComponent.element.field_name === dropdownName) {
              config = innerComponent;
            }
          });
        });
      }
    });
    return config;
  }

  getDependentDropdownName(currentDropdownName: string): string[] {
    const elementConfig = this.getDropdownConfig(currentDropdownName);
    return elementConfig ? elementConfig?.element.dependenton?.split(',') : [];
  }

}
